export const VERIFICATION_STATE = {
    UNVERIFIED: 'unverified',
    VERIFIED: 'verified',
    PENDING: 'pending',
    DENIED: 'denied',
};
